module.exports = __webpack_public_path__ + "img/chart_products.60472738.png";